import { useCallback } from 'react';
import { useApolloClient } from '@apollo/client';
import { Queries } from 'apollo';

const useGetAddresses = () => {
  const client = useApolloClient();
  return useCallback(
    (ssn, sin, email, countryFlag, idType, isMinor = false, minorName = '') =>
      client
        .query({
          fetchPolicy: 'network-only',
          query: Queries.GetVerificationAddresses,
          variables: {
            input: { ssn, sin, email, countryFlag, idType, isMinor, minorName },
          },
        })
        .then(response => (response.data || {}).getVerificationAddresses || []),
    [client],
  );
};

export default useGetAddresses;
